import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@trevor/ui-components';
import flex from '@/css/module/flex.css';
import buttons from '@/css/module/buttons.css';

export type PaginationProps = {
  currentPage: number;
  numberOfPages: number;
  onShowAll: F0;
  onPrevPageClick: F0;
  onNextPageClick: F0;
};

export const Pagination: React.FC<PaginationProps> = ({
  numberOfPages,
  onShowAll,
  currentPage,
  onPrevPageClick,
  onNextPageClick,
}) => (
  <div
    style={{ position: 'absolute', bottom: '0px', left: '0px' }}
    className={`w-100 ${flex.justifyContentCenter} ${flex.alignItemsCenter}`}
  >
    <button
      className={`${buttons.btn} ${buttons.circle} ${buttons.circleSM} margin-right-10`}
      disabled={currentPage === 1}
      onClick={onPrevPageClick}
    >
      <FontAwesomeIcon icon="arrow-left" />
    </button>
    <span>
      Page {currentPage} of {numberOfPages}
    </span>
    <button
      className={`${buttons.btn} ${buttons.circle} ${buttons.circleSM} margin-left-10`}
      disabled={currentPage === numberOfPages}
      onClick={onNextPageClick}
    >
      <FontAwesomeIcon icon="arrow-right" />
    </button>
    <Button variant="secondary" className="margin-left-10" onClick={onShowAll}>
      Show all
    </Button>
  </div>
);
